module.exports = __webpack_public_path__ + "static/media/W1_ROUGH.450a52ca.png";